<template>
    <Overlay :show="loading">
        <div
            v-if="previewUrl"
            class="document-review-preview__frame-wrap"
        >
            <iframe
                :src="previewUrl"
                class="document-review-preview__frame"
                title="review-document"
            />
        </div>

        <BCard v-else class="mb-0">
            <h5 class="mb-1">
                {{ translate('Component(ReviewProcess):source-document', 'Source document') }}
            </h5>
            <p class="text-less-muted mb-1">
                {{ fileReferenceId || '-' }}
            </p>
            <BButton
                variant="outline-primary"
                :disabled="!downloadUrl"
                :href="downloadUrl || null"
                target="_blank"
            >
                {{ translate('Component(Button):open-document', 'Open document') }}
            </BButton>
        </BCard>
    </Overlay>
</template>

<script>
import { BButton, BCard } from 'bootstrap-vue'
import Overlay from '@core/components/common/Overlay.vue'

export default {
    name: 'DocumentReviewPreview',
    components: {
        BButton,
        BCard,
        Overlay,
    },
    props: {
        fileReferenceId: {
            type: String,
            default: null,
        },
        workspaceService: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            downloadUrl: '',
            previewUrl: '',
            loadRevision: 0,
        }
    },
    watch: {
        fileReferenceId: {
            immediate: true,
            handler() {
                this.loadPreview()
            },
        },
    },
    beforeDestroy() {
        this.loadRevision += 1
        this.releasePreviewUrl()
    },
    methods: {
        translate(key, fallback) {
            const translation = this.$t(key)

            return translation && translation !== key ? translation : fallback
        },
        loadPreview() {
            const revision = ++this.loadRevision
            this.releasePreviewUrl()
            this.downloadUrl = ''

            if (!this.fileReferenceId) {
                this.loading = false
                return
            }

            this.loading = true
            this.workspaceService.loadPdfPreview(this.fileReferenceId)
                .then(result => {
                    if (revision !== this.loadRevision) {
                        if (result && result.previewUrl) {
                            URL.revokeObjectURL(result.previewUrl)
                        }
                        return
                    }

                    this.downloadUrl = result && result.downloadUrl ? result.downloadUrl : ''
                    this.previewUrl = result && result.previewUrl ? result.previewUrl : ''
                })
                .catch(() => {
                    if (revision === this.loadRevision) {
                        this.downloadUrl = ''
                        this.releasePreviewUrl()
                    }
                })
                .finally(() => {
                    if (revision === this.loadRevision) {
                        this.loading = false
                    }
                })
        },
        releasePreviewUrl() {
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl)
                this.previewUrl = ''
            }
        },
    },
}
</script>

<style scoped>
.document-review-preview__frame-wrap {
    height: calc(100vh - 13rem);
    min-height: 34rem;
    overflow: hidden;
    border: 1px solid #ebe9f1;
    border-radius: .357rem;
    background: #f8f8f8;
}

.document-review-preview__frame {
    width: 100%;
    height: 100%;
    border: 0;
}
</style>
